import { httpGet, httpPost, httpPut, httpDelete } from '../http';

export interface BackendMilestone {
  id?: number;
  year: string;
  title_zh: string;
  title_en?: string;
  desc_zh?: string;
  desc_en?: string;
  icon?: string;
  sort_order?: number;
  created_at?: string;
  updated_at?: string;
}

export async function getAdminMilestones(): Promise<BackendMilestone[]> {
  return httpGet<BackendMilestone[]>('/admin/milestones');
}

export async function getAdminMilestoneById(id: number): Promise<BackendMilestone> {
  return httpGet<BackendMilestone>(`/admin/milestones/${id}`);
}

export async function createAdminMilestone(data: Partial<BackendMilestone>): Promise<void> {
  return httpPost('/admin/milestones', data);
}

export async function updateAdminMilestone(id: number, data: Partial<BackendMilestone>): Promise<void> {
  return httpPut(`/admin/milestones/${id}`, data);
}

export async function deleteAdminMilestone(id: number): Promise<void> {
  return httpDelete(`/admin/milestones/${id}`);
}
